import React, { useRef } from "react"
import BlogCategories from "./categories"
import Input from "aldoo-ra/Input"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import Text from "aldoo-ra/Text"
import Localization from "aldoo-ra/Localization"
import TextBundle from "aldoo-ra/CMS/text-bundle"

const SearchAndCategories = ({
  categories = [],
  searchQuery = "",
  setSearchQuery,
  searchCategory,
  setSearchCategory,
  getStatusMessage,
  handleSearchChange,
}) => {
  const categoriesRef = useRef(null)
  const { currentLanguage } = Localization()
  const texts = TextBundle({ id: "blog" })
  let isMouseDown = false
  let startX, scrollLeft

  const handleMouseDown = (e) => {
    isMouseDown = true
    startX = e.pageX - categoriesRef.current.offsetLeft
    scrollLeft = categoriesRef.current.scrollLeft
  }

  const handleMouseLeave = () => {
    isMouseDown = false
  }

  const handleMouseUp = () => {
    isMouseDown = false
  }

  const handleMouseMove = (e) => {
    if (!isMouseDown) return
    e.preventDefault()
    const x = e.pageX - categoriesRef.current.offsetLeft
    const walk = (x - startX) * 2
    categoriesRef.current.scrollLeft = scrollLeft - walk
  }

  const handleClear = () => {
    setSearchQuery("")
    setSearchCategory(null)
    const langPrefix = currentLanguage && currentLanguage !== 'en' ? `/${currentLanguage}` : ''
    window.history.replaceState({}, "", `${langPrefix}/blog`)
  }

  return (
    <div className="w-full flex flex-col md:flex-row items-center md:items-start justify-between gap-y-6 mx-auto md:mx-0 mb-6 md:mb-0">
      <div className="relative w-full md:max-w-[60%] lg:max-w-none overflow-hidden">
        <div
          className="categories-container max-w-[650px] mx-auto"
          ref={categoriesRef}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          <BlogCategories
            categories={categories}
            selectedCategory={searchCategory}
            onItemClick={(category) => setSearchCategory(category)}
          />
        </div>
        <div className="fade-overlay"></div>
      </div>
      <div className="flex flex-col w-full md:min-w-[130px] max-w-[408px] md:max-w-[360px] xl:max-w-[415px] items-center md:items-end">
        <div className="relative w-full md:min-w-[130px] max-w-[408px] md:max-w-[360px] xl:max-w-[415px]">
          <Input
            placeholder={texts?.search_placeholder || "Search"}
            variant="aqua_input"
            icon={<MagnifyingGlassIcon className="w-7 h-7" />}
            onChange={handleSearchChange}
            value={searchQuery}
          />
        </div>
        <div className="w-full flex items-center justify-end gap-2 md:gap-4 mt-2 md:mt-4 md:ml-auto">
          <Typography variant="info_16" className="text-text my-0">
            {getStatusMessage()}
          </Typography>
          {(searchQuery || searchCategory) && (
            <Button onClick={handleClear} variant="secondary_xs">
              <Text id="clear_search" className="my-0" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default SearchAndCategories
